var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.ready)?_c('personal-profile-cdc-module',{attrs:{"person":this.person}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }